import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Translate } from "react-localize-redux";
import { updateProfileAction } from "../../../redux/actions/profile.actions";
import BasicProfileForm from "../BasicProfileForm";
import PhoneNumberFormPanel from "../PhoneNumberFormPanel";
import FaxNumberFormPanel from "../FaxNumberFormPanel";
import EmailAddressFormPanel from "../EmailAddressFormPanel";
import WebAddressFormPanel from "../WebAddressFormPanel";
import SocialFormPanel from "../SocialFormPanel";
import ContactsFormPanel from "../ContactsFormPanel";
import AddressFormPanel from "../AddressFormPanel/AddressFormPanel";
import AccountFormPanel from "../AccountFormPanel/AccountFormPanel";
import { asyncValidateEmail } from "../../../services/validation";
import "./styles.scss";
export const EditProfileForm = ({
  handleSubmit,
  slug,
  toggleModal,
  updateProfileAction,
  valid
}) => {
  const renderFormButtons = () => (
    <React.Fragment>
      <button
        type="submit"
        className="btn btn-primary save-btn"
        onClick={toggleModal}
        disabled={!valid}
      >
        <Translate id="saveText" />
      </button>
      <button
        type="button"
        className="btn btn-primary edit-profile-header-cancel-btn"
        onClick={toggleModal}
      >
        <Translate id="cancelText" />
      </button>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit(values => updateProfileAction(slug, values))}
      >
        <div className="row modal-header-row">
          <div className="col-md-9 col-sm-6 edit-profile-header">
            <h3 className="modal-title edit-profile-modal-title">
              <Translate id="editProfileText" />
            </h3>
          </div>
          <div className="col-md-3 col-sm-6">{renderFormButtons()}</div>
        </div>
        <br />
        <br />
        <br />
        <BasicProfileForm />
        <hr />
        <PhoneNumberFormPanel />
        <hr />
        <FaxNumberFormPanel />
        <hr />
        <EmailAddressFormPanel />
        <hr />
        <AddressFormPanel />
        <hr />
        <WebAddressFormPanel />
        <hr />
        <SocialFormPanel />
        <hr />
        <AccountFormPanel />
        <hr />
        <ContactsFormPanel />
        <hr />
        <div className="row">
          <div className="col-md-9 col-sm-6" />
          <div className="col-md-3 col-sm-6">{renderFormButtons()}</div>
        </div>
      </form>
    </React.Fragment>
  );
};

export default reduxForm({
  validate: values => {
    const errors = {};

    console.log("values", values);

    if (!values.first_name) {
      errors.first_name = "Enter a first name";
    }

    if (!values.last_name) {
      errors.last_name = "Enter a last name";
    }

    if (!values.email) {
      errors.email = "Enter an email address";
    }


    console.log("errors", errors);

    return errors;
  },
  asyncValidate: asyncValidateEmail,
  asyncChangeFields: ["email"],
  shouldAsyncValidate: params => {
    if(params.blurredField === "email") {
      return true;
    }
  },
  form: "EditProfileForm"
})(
  connect(
    null,
    { updateProfileAction }
  )(EditProfileForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/EditProfileForm/EditProfileForm.jsx